import { isRM10Evolution, isRM5 } from "__common/constants/products";

export const apiField = 'central_support_choice';
interface centralSupportChoiceField {
  type: string;
  apiField: string;
  label: string;
  data?: centralSupportChoiceOption[];
  id?: string;
  aria_label?: string;
}
interface centralSupportChoiceOption {
  value: number;
  name: string;
}

export enum centralSupportChoices {
    NONE = 0,
    SUPPLEMENTAL_BASE = 1,
    MID_SUPPORT = 2,
}

export function makeConfig(type: string, label: string, productId?: number): centralSupportChoiceField {
  return {
    type,
    label,
    apiField,
    ...(type === 'Select' ? 
    { data: (isRM5(productId) || isRM10Evolution(productId)) ? centralSupportOptionsForRM5RM10Evo : centralSupportOptionsEF2 } : { id: "centralSupportChoice", aria_label: "Central Support Selection" }),
  };
}

export const centralSupportOptionsEF2: centralSupportChoiceOption[] = [
  {
    value: 1,
    name: 'SUPPLEMENTAL BASE',
  },
  {
    value: 2,
    name: 'MID SUPPORT',
  },
];

export const centralSupportOptionsForRM5RM10Evo: centralSupportChoiceOption[] = [
  {
    value: 1,
    name: 'SUPPLEMENTAL BASE',
  },
  {
    value: 2,
    name: 'MID SUPPORT',
  },
];

export const centralSupportChoice = makeConfig('Select', 'centralSupportChoice');

export const centralSupportChoiceForRM = (productId: number) => makeConfig('Select', 'centralSupportChoice', productId);
